import React from 'react';
import './BunnyVideoPlayer.scss';
import { IBunnyVideoPlayerProps } from './IBunnyVideoPlayerProps';
import playerjs from 'player.js';

const BunnyVideoPlayer: React.FC<IBunnyVideoPlayerProps> = (props) => {

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const [hideProgressBar, setHideProgressBar] = React.useState<boolean>(false);

  React.useEffect(() => {
    let player: any;

    if (iframeRef.current) {
      player = new playerjs.Player(iframeRef.current);

      player.on('ready', () => {

        if(props.startTime) {
          setTimeout(() => {
            player.setCurrentTime(props.startTime);
          }, 500);
        }

        player.on('timeupdate', ({ duration, seconds }: any) => {
          if(
            props.setVideoDuration &&
            props.setCurrentSeconds
          ) {
            props.setVideoDuration(duration);
            props.setCurrentSeconds(seconds);
          }
          // const progressPercentage = (seconds / duration) * 100;
          // console.log(`Progress: ${progressPercentage.toFixed(2)}%`);
        });

        player.on('pause', () => {
          //record progress
          if(props.trackProgress) {
            props.trackProgress();
          }
        });

        player.on('ended', () => {
          //record progress
          if(props.trackProgress) {
            props.trackProgress();
          }
        });
      });
    }

    return () => {
      if(player) {
        player.off('ready');
        player.off('timeupdated');
        player.off('pause');
        player.off('ended');
      }

      //record progress
      if(props.trackProgress) {
        props.trackProgress();
      }
    }
  }, [props.startTime, props.videoUrl]);

  React.useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      const message = hideProgressBar ? 'hideProgressBar' : 'showProgressBar';
      (iframeRef.current as any).contentWindow.postMessage(message, '*');
    }
  }, [hideProgressBar]);

  React.useEffect(() => {
    setTimeout(() => {
      setHideProgressBar(!!props.hideProgressBar);
    }, 1500);
  }, [props.hideProgressBar]);

  const getLibraryId = () => {
    return props.videoUrl.split("/")[4];
  }

  const getVideoId = () => {
    return props.videoUrl.split("/")[5];
  }

  return (
    <div 
    className="gp-bunny-video-player-container"
    >
    <iframe 
    ref={iframeRef}
        src={`https://iframe.mediadelivery.net/embed/${getLibraryId()}/${getVideoId()}?autoplay=false`}
    //@ts-ignore
    loading="lazy" 
    className="gp-bunny-video-player-iframe" 
    allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;" 
    allowFullScreen
    >
    </iframe>
    </div>
  )
}

export default BunnyVideoPlayer